import type { IconSvgObject } from './types';

const Clock03Icon: IconSvgObject = [
  ["path", { d: "M19 8.49817H21.5C19.7007 3.74918 14.497 0.998088 9.4604 2.34292C4.09599 3.77528 0.909631 9.25924 2.34347 14.5917C3.77732 19.9241 9.28839 23.0858 14.6528 21.6534C18.6358 20.5899 21.4181 17.2928 22 13.4826", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 7.99841V11.9984L14 13.9984", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Clock03Icon;
